import React from 'react';
import PageTransition from 'gatsby-v2-plugin-page-transitions';

import Page from '../components/global/page';
import NotFoundTemplate from '../templates/not-found-template';

const NotFoundPage = () => (
	<PageTransition>
		<Page title="404">
			<NotFoundTemplate />
		</Page>
	</PageTransition>
);

export default NotFoundPage;
